import { NextStepForm } from "forms";

export default function NextStep() {
  return <NextStepForm />;
}
